import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  ApplyPromoCodeEffects,
  ApplyPromoCodeFacade,
  fromApplyPromoCode,
} from './+state/promo-code';
import { PromoCodeEffects } from './state/promo-code.effects';
import { PromoCodeFacade } from './state/promo-code.facade';
import * as fromPromoCode from './state/promo-code.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      fromPromoCode.PROMO_CODE_FEATURE_KEY,
      fromPromoCode.promoCodeReducer,
    ),
    EffectsModule.forFeature([PromoCodeEffects]),

    // promo-code
    StoreModule.forFeature(
      fromApplyPromoCode.PROMO_CODE_FEATURE_KEY,
      fromApplyPromoCode.reducer,
    ),
    EffectsModule.forFeature([ApplyPromoCodeEffects]),
  ],
  providers: [PromoCodeFacade, ApplyPromoCodeFacade],
  exports: [StoreModule, EffectsModule],
})
export class PromoCodeDataAccessModule {}
